import React, { useCallback } from "react";

import { mdiCalendarBlank } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import useFAST from "../../../contexts/FASTContext";
import useFASTScheduleWebSocket from "../../../hooks/useFASTScheduleWebSocket";
import Button from "../../button/Button";

import type { JSX } from "react";

interface ScheduleButtonProps {
  setShowScheduleModal: (visible: boolean) => void;
}

function ScheduleButton({
  setShowScheduleModal,
}: ScheduleButtonProps): JSX.Element {
  const { state } = useFAST();
  const { t } = useTranslation("editor-fast-channel");
  const { lockSchedule } = useFASTScheduleWebSocket();

  const { lockingAccount } = state.scheduleEditInfo;

  const isExternalLock = Boolean(lockingAccount);

  const handleScheduleClick = useCallback((): void => {
    setShowScheduleModal(true);
    lockSchedule();
  }, [lockSchedule, setShowScheduleModal]);

  return (
    <Button
      className="my-1.25"
      isDisabled={isExternalLock}
      onClick={handleScheduleClick}
      size="md"
      type="button"
    >
      <Icon path={mdiCalendarBlank} size={0.9375} />
      {t("schedule")}
    </Button>
  );
}

export default ScheduleButton;
